export const serializeFilters = (
  filters: { key: string; value: string; condition?: string }[]
): string[] => {
  const result: string[] = [];
  const conditionalPattern = /^\w+\.(eq|gt|gte|lt|lte|like)\(.+\)$/;
  filters.forEach(filter => {
    if (conditionalPattern.test(filter.value)) {
      result.push(filter.value);
    } else if (
      filter.condition &&
      ['eq', 'gt', 'gte', 'lt', 'lte'].includes(filter.condition)
    ) {
      result.push(`${filter.key}.${filter.condition}(${filter.value})`);
    } else {
      result.push(`${filter.key}.eq(${filter.value})`);
    }
  });
  return result;
};
